import './Menu.css';

import { useContext } from 'react';
import { AuthContext } from '../../contextos/authContext';
import { permissoesRotas } from '../../config/rotasRolesPermitidas';
import { CONSTANTES } from '../../config/constantes';

import MenuRender from './MenuRender';
import SpinnerLoading from '../SpinnerLoading';


function Menu() {

    const { signed, loading, permissoes, superUser } = useContext(AuthContext);

    const menusPublicos = [
        {
            'id': 1, 'nome': 'Painel de Indicadores',
            'submenus': [
                {
                    'id': 1.1,
                    'submenu': 'Gráficos',
                    'linkTo': 'graficos'
                },
                {
                    'id': 1.2,
                    'submenu': 'Ficha Técnica Indicadores',
                    'linkTo': CONSTANTES.DOWNLOAD_FICHA_INDICADORES,
                    'linkExterno': true
                }
            ]
        }
    ]

    const menusPrivados = [
        {
            'id': 2, 'nome': 'Administrador',
            'submenus': [
                {
                    'id': 2.1,
                    'submenu': 'Configurações Gerais',
                    'linkTo': 'admin/configuracoes-gerais',
                    'acceptedRoles': permissoesRotas['configuracoesGerais']
                }
            ]
        },
        {
            'id': 3, 'nome': 'Indicadores',
            'submenus': [
                {
                    'id': 3.1,
                    'submenu': 'Informar por Planilha',
                    'linkTo': 'indicador/informar-por-planilha',
                    'acceptedRoles': permissoesRotas['informaIndicador']
                },
                // {
                //     'id': 3.2,
                //     'submenu': 'Ajustar Indicador',
                //     'linkTo': 'indicador/ajustar',
                //     'acceptedRoles': permissoesRotas['ajustaIndicador']
                // }
            ]
        },
        {
            'id': 4, 'nome': 'Relatório de Acompanhamento',
            'submenus': [
                {
                    'id': 4.1,
                    'submenu': 'Novo',
                    'linkTo': 'relatorio-acompanhamento/criar',
                    'acceptedRoles': permissoesRotas['criaRelAcomp']
                },
                // {
                //     'id': 4.2,
                //     'submenu': 'Enviados',
                //     'linkTo': 'relatorio-acompanhamento/enviados',
                //     'acceptedRoles': permissoesRotas['relAcompEnviados']
                // },
                {
                    'id': 4.2,
                    'submenu': 'Download PDF',
                    'linkTo': 'relatorio-acompanhamento/download',
                    'acceptedRoles': permissoesRotas['downloadRelAcomp']
                }
            ]
        },
        {
            'id': 5, 'nome': 'Pendências',
            'submenus': [
                {
                    'id': 5.1,
                    'submenu': 'Responder',
                    'linkTo': 'relatorio-acompanhamento/pendencias/responder',
                    'acceptedRoles': permissoesRotas['respondePendencia']
                },
                // {
                //     'id': 5.2,
                //     'submenu': 'Acompanhar',
                //     'linkTo': 'relatorio-acompanhamento/pendencias/acompanhar',
                //     'acceptedRoles': permissoesRotas['acompanhaPendencias']
                // }
            ]
        },
        {
            'id': 7, 'nome': 'Relatórios',
            'submenus': [
                {
                    'id': 1.1,
                    'submenu': 'Gerar Relatórios',
                    'linkTo': 'relatorios/gerar',
                    'acceptedRoles': permissoesRotas['gerarRelatorios']
                }
            ]
        },
    ]

    function filtraMenuPorRoles(menu, permissoes) {

        return menu.map(secao => {
            const submenusFiltrados = secao.submenus.filter(sub =>
                !sub.acceptedRoles || sub.acceptedRoles.some(p => permissoes.includes(p))
            );

            return {
                ...secao,
                submenus: submenusFiltrados
            };
        })
            .filter(secao => secao.submenus.length > 0); // remove menus sem submenus visíveis
    }

    let menusPrivadosFiltradoPorRoles = [];
    if (superUser) {
        menusPrivadosFiltradoPorRoles = menusPrivados; // super user vê tudo
    } else {
        menusPrivadosFiltradoPorRoles = filtraMenuPorRoles(menusPrivados, permissoes);
    }

    if (loading) {
        return (
            <div style={{ 'backgroundColor': '#f0eded' }}>
                <SpinnerLoading mensagemLoading='Carregando informações do usuário' />
            </div>
        );
    }

    // se estiver logado, junta as informações de rotas publicas com as rotas privadas, com base no perfil do usuario
    const botoesERotas = signed
        ? [...menusPrivadosFiltradoPorRoles, ...menusPublicos]
        : menusPublicos;

    return (
        <MenuRender botoesERotas={botoesERotas} />
    );

}

export default Menu;
